import type { ConfigProviderProps } from 'antd';

import en from 'antd/locale/en_US';

/** Locale map between i18n language with antd international */
export const localeMap: Record<string, ConfigProviderProps['locale']> = {
  en,
};
